import {styled, Select} from "@mui/material"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const StyledSelect = styled(Select)`
    width: 100%;
    height: 2.75rem;

    @media (min-width: ${breakpoints.values.md}px) {
        height: 2.25rem;
        width: 18rem;
    }

    && > div {
        padding: 0 2.25rem 0 1rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 100%;
        border-radius: 0;
        font-family: ${({theme}) => theme.uxfabric.component.inputText.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
        font-weight: ${({theme}) => theme.uxfabric.component.inputText.fontWeight};
        font-size: ${({theme}) => theme.uxfabric.component.inputText.fontSize};
    }
    && > div:focus {
        background-color: transparent;
    }
    &&.selectOpen {
        border-radius: 0.25rem 0.25rem 0 0;
    }
    && .selectBody {
        border-radius: 0 0 0.25rem 0.25rem;
    }
    && > div > .MuiMenu-paper {
        max-height: 18.75rem;
        border-radius: ${({theme}) => theme.uxfabric.shape.global.menu.default.borderRadius};
    }
`
